import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Loading from "../../../../components/Loading";
import styles from './CloudConnector.module.scss';
import commonStyles from "../common.module.scss";
import { useRouter } from "next/router";
import CloudSelector from "./components/CloudSelector";
import {
    setDeploymentCloud,
    wipeBodyCloud,
    wipeBodyServer,
    wipeInstanceData
} from "../../../../redux/actions/DeploymentActions";
import CloudForm from "../../_components/cloud/CloudForm";
import ActionsLayout from "../_layouts/ActionsLayout";
import Card from "../../../../components/card/Card";
import CloudInstances from "../../_components/instance/CloudInstance";
import { getUserTokens } from "../_fetch/tokens/get";
import { deleteUserToken } from "../_fetch/tokens/delete";
import OwnForm from "../../_components/own/OwnForm";

function CloudConnector({
                            modified,
                            project,
                            projectsStatus,
                            compose,
                            clouds,
                            onCloudConfirm,
                            userFetchStatus,
                            messages,
                            requestLoading,
                            user,
                            currentCloud,
                            token,
                            setToken,
                            rerouteCondition,
                            rerouteToDefaults,
                            dispatch
                        }) {

    const router = useRouter();

    const [refresh, setRefresh] = useState(false);
    const [cloud, selectCloud] = useState(null);
    const [tokens, setTokens] = useState([]);
    const [loadingTokens, setLoadingTokens] = useState(true);

    const fetchTokens = () => {
        getUserTokens({
            onSuccess: res => {
                const filtered = res.list.filter(t => t.provider === cloud.code);
                const sorted = filtered.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
                setTokens(sorted);
                setLoadingTokens(false);
            },
            onError: res => {
                setLoadingTokens(false);
            },
        })
    }

    const deleteTokens = ({tokenID, remove}) => {
        setLoadingTokens(true);
        deleteUserToken({
            tokenID,
            remove,
            onSuccess: () => fetchTokens({}),
            onError: () => fetchTokens({}),
        })
    }

    useEffect(() => {
        if (router.isReady) setRefresh(true);
    }, [router.isReady, router.query.project]);

    useEffect(() => {
        if (!!refresh) setTimeout(() => setRefresh(false), 1);
    }, [refresh]);

    useEffect(() => {
        if (cloud) fetchTokens({});
    }, [cloud]);

    useEffect(() => {
        if (rerouteCondition) rerouteToDefaults();
    }, [rerouteCondition])

    if (!!refresh || userFetchStatus !== 'success' && !user) return (
        <Loading
            className={commonStyles.loading}
            icon={{faCode: 'fas fa-chevron-down', animationType: 'bottom'}}
            message={'Loading project...'}
            type={'component'}
            coverOpacity={0}
        />
    );

    const _selectCloud = cloud => {

        selectCloud(cloud || null)
        dispatch(setDeploymentCloud(cloud || null));

        if (!cloud) {
            setTokens([]);
            setToken(null);
            setLoadingTokens(true);
            dispatch(wipeBodyCloud());
            dispatch(wipeBodyServer());
            dispatch(wipeInstanceData());
        }
    }

    const errors = messages.some(m => m.type === 'error');

    if (!compose) return null;

    if (!cloud) return (
        <Card
            className={styles.clouds}
            title={'Select cloud'}
        >
            <CloudSelector clouds={clouds} selectCloud={_selectCloud}/>
        </Card>
    )

    return (
        <form
            className={styles.cloud}
            onSubmit={e => {
                e.preventDefault();
                onCloudConfirm();
            }}
            noValidate={!!token}
        >
            {
                !!currentCloud.config?.selfHosted
                    ? <OwnForm custom onRefuse={() => _selectCloud(null)}/>
                    :
                    <>
                        <CloudForm
                            tokens={tokens}
                            token={token}
                            setToken={setToken}
                            loadingTokens={loadingTokens}
                            deleteToken={deleteTokens}
                            custom
                        />
                        <CloudInstances custom/>
                    </>
            }
            <ActionsLayout
                margin={'10px 0 30px 0'}
                nextIcon={'fas fa-chevron-right'}
                nextTitle={`Continue`}
                nextType={'submit'}
                nextDisabled={
                    !!requestLoading
                    || errors
                    || modified
                    || projectsStatus !== 'success'
                    || !project
                    || !!compose && !currentCloud
                    || loadingTokens
                }
                prevOnClick={() => _selectCloud(null)}
                prevIconLeft={'fas fa-chevron-left'}
                prevTitle={`Clouds`}
                loading={requestLoading}
                disabledGlobal={requestLoading}
            />
        </form>
    )
}

const mapStateToProps = state => ({
    userFetchStatus: state.userData.userFetchStatus,
    user: state.userData.user,
    requestLoading: state.deployment.requestLoading,
    messages: state.deployment.messages,
    currentCloud: state.deployment.currentCloud,
});

export default connect(mapStateToProps)(CloudConnector)